import React, { useCallback, useEffect, useMemo, useState} from 'react'
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import { useDispatch, useSelector } from 'react-redux'

import DatePicker_Dsas from '../../dsasComponents/DatePicker_Dsas.js';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField} from '@mui/material';
import Select_Dsas from '../../dsasComponents/Select_Dsas.js';
import { getCompetitions } from '../../actions/competitions.js';
import { getTeams } from '../../actions/teams.js';
import { updateMatch } from '../../actions/matchs.js';

import DateTimePicker_Dsas from '../../dsasComponents/DateTimePicker_Dsas.js'

import * as api from '../../api'
import { getActualSeason, getDays, season_all } from '../../bdd/bddSTUB.js';

import { discipline_all } from '../../bdd/bddSTUB.js'
import { getUserProvider, isAdminDSAS } from '../../actions/auth.js';
import SelectGroupProvider from '../../dsasComponents/SelectGroupProvider.js';
import { useFetch } from '../../filters/useFetch.js';
import { FETCH_ALL_COMPETITION, FETCH_ALL_TEAM } from '../../constants/actionTypes.js';

const DatePickerGrid = ({params, onEditMatch}) => {

    const { data, rowIndex } = params;

    const [value, setValue] = useState(params.value);

    const handleChangeDateTime = (value) => {
        const newValue = value;
        setValue(newValue);
    }

    useEffect(() => {

        // Vérifier si la valeur a changé avant d'exécuter la logique
        if (value && value !== params.value) {
            onEditMatch({...data, [params.colDef.field] : value});
        }
    }, [value])

    return <DateTimePicker_Dsas
    label={""}
    name={"dateTime"}
    value={value}
    onChange = {handleChangeDateTime}
    isBorder={false}
    />
}

const InputGrid = ({params, onEditMatch}) => {

    const { data, rowIndex } = params;
    const [value, setValue] = useState(params.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
    };

    useEffect(() => {
        // Vérifier si la valeur a changé avant d'exécuter la logique
        if (value && value !== params.value) {
            onEditMatch({...data, [params.colDef.field] : value});
        }
    }, [value]);

    return (
        <TextField 
            sx={{textAlign : 'center', height : '20px'}}
            name="score" 
            variant="outlined"
            /* styles the input component */
            inputProps={{
                style: {
                height : '35px',
                padding : '0 5px',
                textAlign : 'center'
                },
            }}
            fullWidth 
            value={value}
            onChange={onChange}
        />
    )
}


const Results = () => {

    const dispatch = useDispatch()

    const [provider, setProvider] = useState(getUserProvider())
    const [discipline, setDiscipline] = useState('')
    const [season, setSeason] = useState(getActualSeason())

    const [competition, setCompetition] = useState({_id : undefined, teams : []})
    const [columnDefs, setColumnDefs] = useState([])

    const [rowData, setRowData] = useState([]);
    const [actualMatches, setActualMatches] = useState([])

    const emptyFilter = useMemo(() => {
        return {}
    }, [])
    const [competitions] = useFetch(api.fetchCompetitions, emptyFilter, undefined, FETCH_ALL_COMPETITION)

    const teamsFilter = useMemo(() => {
        return {competition : competition._id}
    }, [competition])
    const [teams] = useFetch(api.fetchTeams, teamsFilter, ['competition'], FETCH_ALL_TEAM)

    useEffect(() => {
        setCompetition({_id : undefined, teams : []})

    }, [provider, discipline])

    const competitionsAvailable = useCallback(() => {

        let competitionsAvai = competitions.filter(c => (!provider || c.provider === provider) && (!discipline || c.discipline === discipline)  && (!season || c.season === season))

        /*if(competition && !competitionsAvai.find(c => c._id === competition._id))
            setCompetition({_id : undefined, teams : []})*/

        return competitionsAvai

    }, [provider, discipline, competitions, season])

    const onChooseCompetition = (e) => {
        let choosedComp = competitions.find(c => c._id === e.target.value)

        setCompetition(choosedComp)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onEditMatch = useCallback(async (data) => {

        const {homeTeamScore, awayTeamScore, dateTime, _id, provider} = data

        dispatch(updateMatch(_id, {homeTeamScore, awayTeamScore, dateTime, provider}))
    }, [])

    const inputGrid = useMemo(() => (params) => <InputGrid params={params} onEditMatch={onEditMatch}/>, [onEditMatch])
    const datePickerGrid = useMemo(() => (params) => <DatePickerGrid params={params} onEditMatch={onEditMatch}/>, [onEditMatch])

    // La competition est choisie
    useEffect(() => {
        (async () => {

            if(!competition._id){
                setRowData([])
                return
            }
            

            setColumnDefs([
                {   
                    field: 'day', 
                    headerName: 'Journée',
                    width: 175,
                    sortable: true,
                },
                {   
                    field: 'dateTime', 
                    headerName: 'Date', 
                    cellRenderer : datePickerGrid,
                    width: 300,
                    editable: true,
                    

                },
                {
                    field: 'homeTeam', 
                    headerName: 'Equipe domicile',
                    width: 270,
                    cellStyle: { textAlign: 'right' }
                },
                {
                    field: 'homeTeamScore', 
                    headerName: 'B',
                    cellRenderer : inputGrid,
                    width: 50,
                    cellStyle: { padding: 0 }
                },
                {
                    field: 'awayTeamScore', 
                    headerName: 'B',
                    cellRenderer : inputGrid,
                    width: 50,
                    cellStyle: { padding: 0 }
                },
                { 
                    field: 'awayTeam', 
                    headerName: 'Equipe extérieure',
                    width: 270,
                    cellStyle: { textAlign: 'left' }
                }
            ])

            // On veut récupérer les matchs de cette compétition
            let {data : matchsCompetition} = await api.fetchMatchsByCompetition(competition._id)

            let rowData = []

            matchsCompetition.forEach(match => {
                let CONSThomeTeam = teams.find(t => t._id === match.homeTeam)
                let CONSTawayTeam = teams.find(t => t._id === match.awayTeam)

                let dateTime = match.dateTime
                let homeTeam = CONSThomeTeam.name ?? ''
                let homeTeamScore = match.homeTeamScore ? match.homeTeamScore : 0
                let awayTeam = CONSTawayTeam.name ?? ''
                let awayTeamScore = match.awayTeamScore ? match.awayTeamScore : 0
                let day = match.day
                let _id = match._id

                let provider = match.provider

                let row = {day, dateTime, homeTeam, awayTeam, _id, homeTeamScore, awayTeamScore, provider}
                rowData.push(row)
            })

            setRowData(rowData)
        })()

    }, [competition, teams])

    

    return (
        <Box>
            
            <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                {/*Discipline*/} 
                <FormControl sx={{ width : '50%' }} >
                    <InputLabel id={"disciplinecompet"}>Discipline</InputLabel>
                    <Select 
                        labelId={'disciplinecompet'}
                        id={"disciplinecompetselect"}
                        name={'discipline'}
                        value={discipline}
                        label={'Discipline'}
                        onChange={(e) => setDiscipline(e.target.value)}
                    >
                        {discipline_all && discipline_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>

                    <Select 
                        labelId={'seasoncompet'}
                        id={"seasoncompetselect"}
                        name={'season'}
                        value={season}
                        label={'Saison'}
                        onChange={(e) => setSeason(e.target.value)}
                    >
                        {season_all && season_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                {isAdminDSAS() && <SelectGroupProvider value={provider} onChange={(e) => setProvider(e.target.value)}/>}
            </Box>
            




            <Select_Dsas label={"Compétition"} name="competition" items={competitionsAvailable()} value={competition._id} onChange={onChooseCompetition}></Select_Dsas>

            <div className="ag-theme-alpine" style={{boxSizing: 'border-box' ,height : 500}}>
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
        </Box>
        
    );
}

export default Results